import React from 'react';
import { Button } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useHistory, useLocation } from 'react-router-dom';
import { navigateToQuoteForm } from '../../utils/quoteNavigation';
import { trackEvent } from '../../utils/analytics';
import { business } from '../../theme/tokens';

type Size = 'medium' | 'large';

export const GetQuoteButton: React.FC<{ size?: Size; label?: string; fullWidth?: boolean }> = ({
  size = 'large',
  label = 'Get a free quote',
  fullWidth,
}) => {
  const history = useHistory();
  const location = useLocation();
  return (
    <Button
      variant="contained"
      size={size}
      fullWidth={fullWidth}
      endIcon={<ArrowForwardIcon />}
      onClick={() => {
        trackEvent('quote_cta_click', { cta_label: label });
        navigateToQuoteForm(history, location);
      }}
    >
      {label}
    </Button>
  );
};

export const CallButton: React.FC<{ size?: Size; label?: string; fullWidth?: boolean }> = ({
  size = 'large',
  label = business.phoneDisplay,
  fullWidth,
}) => (
  <Button
    variant="outlined"
    size={size}
    fullWidth={fullWidth}
    href={business.phoneHref}
    startIcon={<PhoneIcon />}
  >
    {label}
  </Button>
);
